import { loginUser, logout as logoutAdminSession } from "../redux/slices/authSlice";
import { logoutAppUser } from "../app/redux/appAuthSlice";
import { isAdminHost } from "./adminHost";

export const isStaffRole = (role) =>
  role === "admin" || role === "super_admin";

/** Admin portal destination only on admin.betbond.app — never on the main site. */
export const getPostLoginDestination = (role, fallback = "/app/bethouse") =>
  isStaffRole(role) && isAdminHost() ? "/admin" : fallback;

/** Website-admin JWT — required for /admin API calls (separate from app JWT). */
export const syncStaffAdminSession = async (dispatch, { email, password }) =>
  dispatch(loginUser({ email, password })).unwrap();

export const logoutAllSessions = (dispatch) => {
  dispatch(logoutAdminSession());
  dispatch(logoutAppUser());
};
